import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { map } from 'rxjs/operators';

import { AuthRoutingService } from '../services/auth-routing.service';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthAnonymousGuard implements CanActivate, CanActivateChild {
  constructor(
    private authService: AuthService,
    private routing: AuthRoutingService
  ) {}

  canActivate() {
    return this.authService.isAuthenticated$.pipe(
      map((isAuthenticated) =>
        isAuthenticated ? this.routing.getUserHome() : true
      )
    );
  }

  canActivateChild() {
    return this.canActivate();
  }
}
